import React from 'react';
import styled from 'styled-components';

import { IstoreItem } from '@typings/store/storeItem.interface';
import { getStoreStockStatus } from '@utils/store/storeAccess';

const Badge = styled.span<{ $isSoldOut: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  padding: 3px 6px;
  border-radius: 4px;
  border: 1px solid
    ${({ $isSoldOut }) =>
      $isSoldOut
        ? 'var(--warningColor, var(--primaryColor))'
        : 'var(--lineColor)'};
  color: ${({ $isSoldOut }) =>
    $isSoldOut
      ? 'var(--warningColor, var(--primaryColor))'
      : 'var(--subTextColor)'};
  background-color: var(--backgroundColor);
  font-size: 11px;
  line-height: 1.2;
  white-space: nowrap;
`;

type Props = {
  data: IstoreItem;
  className?: string;
};

function StoreStockBadge({ data, className }: Props) {
  const stockStatus = getStoreStockStatus(data);
  if (!stockStatus) return null;

  return (
    <Badge className={className} $isSoldOut={stockStatus.isSoldOut}>
      재고 {stockStatus.remaining} / {stockStatus.total}
    </Badge>
  );
}

export default React.memo(StoreStockBadge);
